import { render, staticRenderFns } from "./PdfPreview.vue?vue&type=template&id=827b0778&scoped=true&"
import script from "./PdfPreview.vue?vue&type=script&lang=js&"
export * from "./PdfPreview.vue?vue&type=script&lang=js&"
import style0 from "./PdfPreview.vue?vue&type=style&index=0&id=827b0778&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "827b0778",
  null
  
)

export default component.exports